<template>
  <div class="hero-banner">
      <picture>
        <source media="(min-width: 768px)" :srcset="heroBanner" />
        <img :src="heroBannerMobile" alt="Lottery Balls" />
      </picture>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from '@/composables/useTheme'

const { getAssetPath } = useTheme()

const heroBanner = computed(() => getAssetPath('heroBanner') || '/img/images/banners/banner-lg.png')
const heroBannerMobile = computed(() => getAssetPath('heroBannerMobile') || '/img/images/banners/banner-sm.png')
</script>

<style scoped>
.hero-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

picture {
  width: 100%;
  height: auto;
  display: block;
}

img {
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

</style> 